import {objectVariable} from "@/js/document/document";

export function translate(item, path, iso, fallback) {
  return (item?.properties?.translations
  && item.properties.translations.hasOwnProperty(iso)
  && objectVariable(item.properties.translations[iso], path)
    ? objectVariable(item.properties.translations[iso], path)
    : objectVariable(item, path)) || fallback || '';
}
